import { UploadImageInterface } from "@/enums/image.interface";

export class UploadImage implements UploadImageInterface {
  public image: any;

  constructor(image) {
    this.image = image;
  }

  rotate(deg) {
    this.image.rotate(deg);
  }
  flipX(scale) {
    this.image.scaleX(scale);
  }
  flipY(scale) {
    this.image.scaleY(scale);
  }
  cropImage() {
    return this.image.getCroppedCanvas().toDataURL();
  }
  reset() {
    this.image.reset();
  }
  clear() {
    this.image.clear();
  }
  distroy() {
    this.image.distroy();
  }
  crop() {
    this.image.initCrop();
  }
  zoomTo(deg) {
    this.image.zoomTo(deg);
  }
}
